app.service('operatorBar', function (loading, html, localStorage, pageConfig, warrantyQuestionnaire) {
	var $self;
	var customerLogged, customerLoggedName;

	function warrantyQuestionnaireSetup() {
		// logika pierwszego czyszczenia ankiet w Trybie Operatorskim po zmianie zalogowanego klienta
		// w przypadku gdy ten został wylogowany po zakończeniu zamówienia lub w innym przypadku na starym froncie
		customerLoggedName = pageConfig.getData('operator').frontUserLoggedName;
		if (customerLogged) {
			if (localStorage.getItem('customer') && localStorage.getItem('customer') != '(nowy klient)' && customerLoggedName != localStorage.getItem('customer')) {
				warrantyQuestionnaire.clearWarrantyQuestionnaire();
			}
			localStorage.setItem('customer', customerLoggedName);
			localStorage.setItem('isLoggedCustomer', true);
		} else {
			if (localStorage.getItem('isLoggedCustomer') == 'true' && localStorage.getItem('customer') != '(nowy klient)') {
				warrantyQuestionnaire.clearWarrantyQuestionnaire();
				localStorage.setItem('isLoggedCustomer', false);
			}
			localStorage.removeItem('customer');
		}
	}

	function setEvents() {
		$('.js-logout-operator', $self).click(function () {
			logoutOperator();
		});
		$('.js-clear-cart', $self).click(function () {
			warrantyQuestionnaire.clearWarrantyQuestionnaire();
			clearCart();
		});
		$('.js-logout-customer', $self).click(function () {
			logoutCustomer();
		});
	}
	function logoutCustomer() {
		warrantyQuestionnaire.clearWarrantyQuestionnaire();//usun zapamietane ankiety
		loading.start();
		$.ajax({
			url: '/front-operator-bar-logout.ltr',
			type: 'POST',
			complete: function () {
				loading.redirect({
					href: '/cart.bhtml',
					soft: false
				});
			}
		});
	}

	function clearCart() {
		loading.start();
		UA.interaction('Tryb Operatorski Ścieżka', 'Belka', 'Wyczyść koszyk');

		$.ajax({
			url: '/clear-cart.ltr',
			dataType: 'json',
			complete: function () {
				location.reload();
			}
		});
	}
	function logoutOperator() {
		html.remove('operator-logged');
		warrantyQuestionnaire.clearWarrantyQuestionnaire();
		loading.redirect({
			href: '/konto-wyloguj.bhtml',
			soft: false
		});
	}
	function init() {
		$self = $('#top-operator-bar');
		if ($self.length && $('.operator-bar', $self).length) {
			customerLogged = pageConfig.getData('operator').frontUserLogged;
			localStorage.setItem('outFromOrderPath', customerLogged); // ustawia wartość w localstorage do prezentacji modala o aktywnym kliencie przy wyjściu ze ścieżki
			html.add('operator-logged');
			warrantyQuestionnaireSetup();
			setEvents();
		}
	}
	return {
		init
	};
});
